import React, {useEffect, useMemo, useState} from "react";
import {Container, FormGroup, Input} from "reactstrap";
import TfBreadcrumbs from "../../components/Common/TfBreadcrumbs";
import {SubscriberBreadcrumb, SubscriptionBreadcrumb} from "../../common/data/parties";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useAsyncDebounce} from "react-table";
import {GET_SUBSCRIPTION_DATA} from "../../store/Subscriptions/actiontype";
import {CommonValue} from "../Parties/PartiesCol";
import {Edit} from "../Settings/SettingsCol";
import SubscribersTable from "./components/SubscribersTable";
import {getSubscriptionsSummary} from "../../store/Subscriptions/actions";
import {getSubscriberSummaryList} from "../../store/Subscribers/actions";

const Subscribers = () => {
    const [value, setValue] = useState('');
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(0);
    const [previewModal, setPreviewModal] = useState(false);
    const { subscribersGroupSummary } = useSelector((state) => state.subscriberReducer);
    const dispatch = useDispatch();

    const onChange = useAsyncDebounce(value => {
        //console.log(value);
    }, 200);

    useEffect(() => {
        if (currentPage !== '' && currentPage !== undefined) {
            let url = `?page=${currentPage}&size=10`;
            dispatch(getSubscriberSummaryList(url));
        }
    }, [dispatch, currentPage])

    const viewPopupHandler = (data) => {
        //console.log("viewPopupHandler", data);
        navigate(`/network/subscriber/details`, {
            state: {
                id: data.id || '',
                data: data
            },
        });
    }

    const subscribersColumns = useMemo(
        () => [
            {
                Header: "Subscription Code",
                accessor: "code",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            },
            {
                Header: "Subscription Name",
                accessor: "name",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            },
            {
                Header: "Total Subscriber",
                accessor: "totalRecords",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            },
            {
                Header: "Active",
                accessor: "totalActiveRecords",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            },
            {
                Header: "New Subscribers",
                accessor: "totalNewRecords",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            },
            {
                Header: "InActive",
                accessor: "totalInactiveRecords",
                filterable: true,
                disableFilters: true,
                Cell: (cellProps) => {
                    return (
                        <CommonValue
                            cellProps={cellProps}
                            viewPopupHandler={viewPopupHandler}
                        />
                    );
                },
            }
        ], []);

    return(
        <>
            <div className="page-content settings_users_wrapper">
                <Container fluid>
                    <div className="main_freight_wrapper">
                        <div className="tf_top_breadcrumb_rate_wrap">
                            <TfBreadcrumbs breadcrumb={SubscriberBreadcrumb}/>
                            <div className="tf_box_wrap d-flex">
                                <div className="sh_box flex-grow-1">
                                    <p className="box_title">Active Subscriber</p>
                                    <div className="sh_inquiry_rate">{subscribersGroupSummary ? subscribersGroupSummary.totalActiveRecords : ""}
                                        <span className='green_text'>0%</span>
                                    </div>
                                </div>
                                <div className="sh_box flex-grow-1">
                                    <p className="box_title">New Subscriber</p>
                                    <div className="sh_inquiry_rate">{subscribersGroupSummary ? subscribersGroupSummary.totalNewRecords : ""}
                                        <span className='green_text'>0%</span>
                                    </div>
                                </div>
                                <div className="sh_box flex-grow-1">
                                    <p className="box_title">InActive Subscriber</p>
                                    <div className="sh_inquiry_rate">{subscribersGroupSummary ? subscribersGroupSummary.totalInactiveRecords : ""}
                                        <span className='green_text'>0%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <SubscribersTable
                            columns={subscribersColumns}
                            data={subscribersGroupSummary.content || []}
                            isGlobalFilter={true}
                            customPageSize={10}
                            component={"Subscriptions"}
                            loader={false}
                            setCurrentPage={setCurrentPage}
                            totalPages={subscribersGroupSummary.totalPages || 0}
                            totalEntries={subscribersGroupSummary.totalElements || 0}
                        />
                    </div>
                </Container>
            </div>
        </>
    );
}

export default Subscribers;
